import React from 'react';
import InlineLoader from './InlineLoader';

import './_EntityBlockLoader.scss';

const EntityBlockLoader = () => <InlineLoader className="EntityBlockList__loader" />;

export default EntityBlockLoader;
